import { render, staticRenderFns } from "./editable-fields.vue?vue&type=template&id=973b1920&scoped=true"
import script from "./editable-fields.vue?vue&type=script&lang=js"
export * from "./editable-fields.vue?vue&type=script&lang=js"
import style0 from "./editable-fields.vue?vue&type=style&index=0&id=973b1920&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973b1920",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('973b1920')) {
      api.createRecord('973b1920', component.options)
    } else {
      api.reload('973b1920', component.options)
    }
    module.hot.accept("./editable-fields.vue?vue&type=template&id=973b1920&scoped=true", function () {
      api.rerender('973b1920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/editable-fields.vue"
export default component.exports